import { SVGProps, Ref, forwardRef, useId } from 'react';

export const EmojiHalfsmile3dSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => {
    const _uniqueId = useId();
    return (
        <svg
            width={16}
            height={16}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <g filter={`url(#${_uniqueId}filter0_i_8745_62)`} suppressHydrationWarning>
                    <path
                        d="M8 .5C1.438.5.5 1.438.5 8s.938 7.5 7.5 7.5 7.5-.937 7.5-7.5S14.563.5 8 .5"
                        fill={`url(#${_uniqueId}paint0_radial_8745_62)`}
                        suppressHydrationWarning
                    />
                </g>
                <path
                    d="M4.677 5.466c.205-.246.527-.4.988-.4.462 0 .784.154.988.4.202.242.279.56.279.866s-.077.623-.279.866c-.204.245-.526.4-.988.4s-.783-.155-.988-.4c-.202-.243-.278-.56-.278-.866 0-.307.076-.624.278-.866"
                    fill="#79610C"
                />
                <path
                    d="M9.343 5.466c.204-.246.526-.4.988-.4s.783.154.988.4c.202.242.278.56.278.866s-.076.623-.278.866c-.205.245-.527.4-.988.4-.462 0-.784-.155-.988-.4-.202-.243-.279-.56-.279-.866 0-.307.077-.624.279-.866"
                    fill="#79610C"
                />
                <path
                    d="M7.175 10.985a.47.47 0 0 1-.143-.32h-1.4c0 .501.209.944.523 1.278.45.48 1.126.754 1.843.754s1.393-.274 1.844-.754c.313-.334.522-.777.522-1.279h-1.4c0 .098-.038.21-.143.32-.158.169-.45.313-.823.313s-.665-.144-.823-.312"
                    fill="#79610C"
                />
            </g>
            <defs>
                <filter
                    id={`${_uniqueId}filter0_i_8745_62`}
                    x={0.5}
                    y={-2}
                    width={17.5}
                    height={17.5}
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                    suppressHydrationWarning
                >
                    <feFlood floodOpacity={0} result="BackgroundImageFix" />
                    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dx={2.5} dy={-2.5} />
                    <feGaussianBlur stdDeviation={2.5} />
                    <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" />
                    <feBlend mode="normal" in2="shape" result="effect1_innerShadow_8745_62" />
                </filter>
                <radialGradient
                    id={`${_uniqueId}paint0_radial_8745_62`}
                    cx={0}
                    cy={0}
                    r={1}
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(11.211 3.3125) rotate(127.875) scale(13.3614)"
                    suppressHydrationWarning
                >
                    <stop stopColor="#F9E193" />
                    <stop offset={1} stopColor="#FF9900" />
                </radialGradient>
            </defs>
        </svg>
    );
});
EmojiHalfsmile3dSize16Glyph.displayName = 'EmojiHalfsmile3dSize16Glyph';
